import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../../web/validation";
import {Entity} from "../entity";

export const ServiceTypeModeCodec = t.intersection([
  t.type({
    id: t.string,
    companyId: t.string,
    serviceTypeId: t.string,
    mode: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
  t.partial({
    createdById: t.string,
    lastModifiedById: t.string,
  }),
]);

export type ServiceTypeMode = t.TypeOf<typeof ServiceTypeModeCodec>;

@Exclude()
export class ServiceTypeModeEntity implements Entity {
  @Expose()
  id!: string

  @Expose()
  companyId!: string;

  @Expose()
  serviceTypeId!: string;

  @Expose()
  mode!: string;

  @Expose()
  resetStatus?: string;

  @Expose()
  createdById?: string;

  @Expose()
  lastModifiedById?: string;

  @Expose()
  createDttm!: number;

  @Expose()
  lastModifiedDttm!: number;

  readonly entityType = 'SERVICETYPEMODE';

  get displayName(): Readonly<string> {
    return this.id;
  }

  /**
   * Constructor for ServiceTypeModeEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: ServiceTypeMode): ServiceTypeModeEntity {
    return plainToInstance(ServiceTypeModeEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<ServiceTypeMode> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(ServiceTypeModeCodec, object);
  }

  asTypeValue(): ServiceTypeMode {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(ServiceTypeModeCodec, object);
  }
}

export type ServiceTypeModeSaveDTO = {
  companyId: string,
  serviceTypeId: string,
  modeCode: string
}
